import React from 'react';
import './StatusFrame.css';

// One status as a frame: a coloured heading with the count and a chevron, and the cards of that status inside. Red first, then
// orange, then green, on every page that groups by status. tone: bad, warn, ok or other.
export default function StatusFrame({ tone, title, count, extra, onExtra, folded, onToggle, children }) {
  return (
    <section className={`sf sf--${tone}${folded ? ' is-folded' : ''}`}>
      <button type="button" className="sf__h" aria-expanded={!folded} onClick={onToggle}>
        <span className="sf__d" aria-hidden="true" />
        <b>{title}</b>
        <span className="sf__n">{count}</span>
        {extra ? (onExtra
          ? <span className="sf__x sf__x--link" role="link" tabIndex={0} onClick={(e) => { e.stopPropagation(); onExtra(); }} onKeyDown={(e) => { if (e.key === 'Enter') { e.stopPropagation(); onExtra(); } }}>{extra}</span>
          : <span className="sf__x">{extra}</span>) : null}
        <svg className="sf__c" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
      </button>
      {!folded && <div className="sf__b">{children}</div>}
    </section>
  );
}
